import { render, staticRenderFns } from "./PriorityForm.vue?vue&type=template&id=b831235a"
import script from "./PriorityForm.vue?vue&type=script&lang=js"
export * from "./PriorityForm.vue?vue&type=script&lang=js"
import style0 from "./PriorityForm.vue?vue&type=style&index=0&id=b831235a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports